
export const validarLimites = (value, max = 0, min = 0, msg = '') => {

    if (value < min ||
        value > max) {
        return `${msg}`
    }

    return true

}


